// API Configuration
const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
  apiUrl: `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'}/api`
};

/**
 * Get headers with country code
 * @param {string} country - Country name
 * @returns {Object} Headers object with X-Country-Code
 */
export const getCountryHeader = (country) => {
  if (!country) {
    // Try to get from localStorage as fallback
    country = localStorage.getItem('selectedCountry');
  }
  
  return country ? { 'X-Country-Code': country } : {};
};

/**
 * Get default headers for API requests
 * @param {string} country - Optional country name
 * @returns {Object} Headers object
 */
export const getDefaultHeaders = (country = null) => {
  return {
    'Content-Type': 'application/json',
    ...getCountryHeader(country)
  };
};

export default config;
